import React, { Component } from 'react'
import { Div, P } from '@driftt/tide-core-legacy'
import './style.styl'

class AppLink extends Component {

  goToApp = () => {
    const { app } = this.props
    window.location.href = app.url
  }

  render() {
    const { app } = this.props
    return (
      <Div className="app-link-container" onClick={this.goToApp}>
        <Div className="app-link-entry">
          <img width={18} height={18} src={app.iconSrc} alt="app-switcher"/>
          <P href={app.url} className="app-link-text">
            {app.name}
          </P>
        </Div>
      </Div>
  )}
}

export default AppLink



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/AppSwitcher/AppLink/index.js